import PropTypes from "prop-types";
import { Navigate, Outlet, useParams } from "react-router-dom";

function RoleRoute({ allowed }) {
  const { id } = useParams();
  return allowed ? <Outlet /> : <Navigate to={`/communities/${id}`} replace />;
}

RoleRoute.propTypes = {
  allowed: PropTypes.bool.isRequired,
};

export default RoleRoute;
